import { Player } from '@lottiefiles/react-lottie-player';
import { isFunction } from '@mechhive/helpers';

type CheckmarkModalProps = {
  onComplete?: () => void;
}

export const CheckmarkModal = ( { onComplete } : CheckmarkModalProps ) => {

  const handleEvent = ( event: string  ) => {
    if ( 
      ( event === 'complete' || event === 'error' ) && 
      isFunction( onComplete ) 
    ) {
      onComplete();
    }
  }

  return (
    <div className={ 'fixed inset-0 bg-black/50 z-50 backdrop-blur flex items-center justify-center' }>
      <div className={ 'w-24 h-24' }>
        <Player 
          src={ '/animations/checkmark.json' }
          autoplay
          onEvent={ handleEvent }
        />
      </div>
    </div>
  )
}
